import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-review-castle",
  "use": "foquz-icon-review-castle-usage",
  "viewBox": "0 0 17 15",
  "content": "<symbol viewBox=\"0 0 17 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-review-castle\"><path d=\"M6.25 7h4.5M5.5 4H4a3 3 0 000 6h1.5m6-6H13a3 3 0 010 6h-1.5\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol